const _key = "__user__facopp_foto_premio";

class Inscrito {


    onLogin(fn){
        this.fn = fn;
    }   
    getInscrito() {
        var u = window.sessionStorage[_key];
        return u && JSON.parse(u) || null;
    }

    setInscrito(user) {
        window.sessionStorage[_key] = JSON.stringify(user);
        this.fn(user);
    }
};

export default new Inscrito();


// WEBPACK FOOTER //
// ./src/modules/inscrito.js